import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=a7dc2a8a&scoped=true&"
import script from "./reset.vue?vue&type=script&lang=js&"
export * from "./reset.vue?vue&type=script&lang=js&"
import style0 from "./reset.vue?vue&type=style&index=0&id=a7dc2a8a&lang=scss&scoped=true&"
import style1 from "./reset.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dc2a8a",
  null
  
)

export default component.exports